<template>
	<b-jumbotron
		header="Tiermittel-Datenbank"
		class="m-5"
	>
		<p>{{ $t('maintenanceText') }}</p>
	</b-jumbotron>
</template>

<script>
export default {
	name: 'MaintenanceLayout'

};
</script>
